/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SvgNodeList } from '../../models/svg-node-list';

export interface GetSvgTags$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The uid of the selected svg
 */
  svgUid: string;
}

export function getSvgTags(http: HttpClient, rootUrl: string, params: GetSvgTags$Params, context?: HttpContext): Observable<StrictHttpResponse<SvgNodeList>> {
  const rb = new RequestBuilder(rootUrl, getSvgTags.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('svgUid', params.svgUid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SvgNodeList>;
    })
  );
}

getSvgTags.PATH = '/stations/{uid}/svg/{svgUid}/tags';
